
import Vue from 'vue'

const actions = {

    async GetByServiceProject(context, idServiceProject) {
        try {
            const result = await Vue.prototype.$vanKirkApi.get(`lot-coverage/by-project/${idServiceProject}`, {
                headers: { "content-type": "application/json" }
            });
            if (result.data) {
                return result.data.result;
            }
            return null;
        } catch (ex) {
            return { success: false, message: `Error loading lot coverage: [${ex}]` };
        }
    },

    async Save(context, request) {
        try {
            const result = await Vue.prototype.$vanKirkApi.post("lot-coverage/save", request, {
                headers: { "content-type": "application/json" }
            });
            if (result.data) {
                return result.data.result;
            }
            return null;
        } catch (ex) {
            return { success: false, message: `Error saving lot coverage: [${ex}]` };
        }
    },
};

export default {
    namespaced: true,
    actions,
};
